<template>
  <div v-if="isVisibleDialog" :class="$style.container">
    <transition name="fade" appear>
      <div :class="$style.overlay" @click.stop="handleClose"></div>
    </transition>

    <transition name="bottom-animate" appear>
      <div :class="$style.template">
        <div v-if="$slots.hasOwnProperty('title')" :class="$style.title">
          <slot name="title" />
        </div>

        <div v-scrollbar="{ id: `scrollbar-${scrollbarId}` }" :class="$style.content">
          <scrollbar-vertical
            :id="`scrollbar-${scrollbarId}`"
            :class="$style.scrollbar"
          />

          <div>
            <slot name="default" />
          </div>

          <div v-if="isVisibleFooter" :class="$style.footer">
            <slot name="footer">
              <div :class="[$style.action, $style.submit]">
                <slot name="submit" />
              </div>

              <div :class="[$style.action, $style.cancel]">
                <slot name="cancel" />
              </div>
            </slot>
          </div>

        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import { generateRandomString } from 'lib/utils/string';

import { ScrollbarDirective, ScrollbarVertical } from 'molecules/scrollbar';

export default {
  name: 'Dialog',
  components: {
    ScrollbarVertical,
  },
  directives: {
    'scrollbar': ScrollbarDirective,
  },
  props: {
    value: Boolean,
  },
  data() {
    return {
      isVisibleDialog: false,
      scrollbarId: generateRandomString(),
    };
  },
  computed: {
    isVisibleFooter() {
      const { footer, submit, cancel } = this.$slots;

      if (this.$validate.isUndefined(submit) && this.$validate.isUndefined(cancel)) {
        return this.$validate.isFixedLengthArray(footer, 1);
      }

      return true;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.isVisibleDialog = val;
      },
    },
    isVisibleDialog: {
      immediate: true,
      handler(val) {
        if (val) {
          disableBodyScroll(document.body);
        } else {
          enableBodyScroll(document.body);
        }

        this.$emit('input', val);
      },
    },
  },
  methods: {
    handleClose() {
      this.isVisibleDialog = false;

      this.$nextTick(() => {
        this.$emit('close');
      });
    },
  },
};
</script>

<style lang="sass" module>
  @import '~styles/components/base/dialog'
</style>

<style lang="sass" scoped>
  .bottom-animate-enter-active
    transition: transform .5s

  .bottom-animate-enter
    transform: translateY(100%)
</style>
